import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import './i18n';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about servio        <HugeTitle>{translate('welcome')}</HugeTitle>
//
const updateServiceWorker = (registration) => {
  const waitingServiceWorker = registration.waiting;

  if (waitingServiceWorker) {
    waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });

    waitingServiceWorker.addEventListener('statechange', (event) => {
      if (event.target.state === 'activated') {
        window.location.reload();
      }
    });
  }
}

serviceWorker.register({
  onSuccess: () => {
    console.log('sw init');
  },
  onUpdate: (registration) => {
    console.log('sw update');
    updateServiceWorker(registration);
  },
});
